export const MODAL_STYLE_SETTINGS = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: '100500',
  },

  content: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%,-50%)',

    minHeight: '10rem',
    minWidth: '20rem',
    maxWidth: '60rem',

    border: '0',
    padding: '0',
    overflow: 'unset',
  }
};
